// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--JIc+m","imageWrapper":"imageWrapper--ELXdV","aliasWrapper":"aliasWrapper--LP77A"};